import axios from 'axios'
import { BUSCAR_ENCOMENDAS_AVULSAS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil'
import { URL } from '../../util/ambienteActions'

const OFFLINE_AWARE_CONFIG = {
  headers: {
    ...SLOW_REQUEST_CONFIG.headers,
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

export default function buscarEncomendasAvulsas (idEmpresa, filtro) {
  const params = new URLSearchParams()
  if (filtro.numeroOs) params.append('numeroOs', filtro.numeroOs)
  if (filtro.numeroPedido) params.append('numeroPedido', filtro.numeroPedido)
  if (filtro.vendedor) params.append('vendedor', filtro.vendedor)
  if (filtro.descricao) params.append('descricao', filtro.descricao)
  if (filtro.remetente) params.append('remetente', filtro.remetente)
  if (filtro.destinatario) params.append('destinatario', filtro.destinatario)
  if (filtro.situacao) params.append('situacao', filtro.situacao)
  if (filtro.valorMinimo) params.append('valorMinimo', filtro.valorMinimo)
  if (filtro.valorMaximo) params.append('valorMaximo', filtro.valorMaximo)
  if (filtro.dataVendaInicio) params.append('dataVendaInicio', filtro.dataVendaInicio)
  if (filtro.dataVendaFim) params.append('dataVendaFim', filtro.dataVendaFim)
  if (filtro.dataItinerarioInicio) params.append('dataItinerarioInicio', filtro.dataItinerarioInicio)
  if (filtro.dataItinerarioFim) params.append('dataItinerarioFim', filtro.dataItinerarioFim)
  params.append('from', filtro.from || 0)
  params.append('size', filtro.size || 20)

  const url = `${URL}/encomendas-avulsas/empresa/${idEmpresa}?${params.toString()}`
  return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG).then(
    response => dispatch({
      type: BUSCAR_ENCOMENDAS_AVULSAS,
      payload: response.data
    })
  ).catch(erro => {
    if (!navigator.onLine || !erro.response) {
      return dispatch({ type: BUSCAR_ENCOMENDAS_AVULSAS, payload: { encomendasAvulsas: [], total: 0 } })
    }
    throw erro
  })
}
